import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import * as i0 from "@angular/core";
export class UrlShortenerModalModule {
}
UrlShortenerModalModule.ɵfac = function UrlShortenerModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || UrlShortenerModalModule)(); };
UrlShortenerModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: UrlShortenerModalModule });
UrlShortenerModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, FormsModule, ModalBaseModule] });
